export const SELECT_LANGUAGE = "SELECT_LANGUAGE";
export const EMAIL = "EMAIL";
export const LOGIN = "LOGIN";
export const LOGOUT = "LOGOUT";
export const UPDATE_PROFILE = "UPDATE_PROFILE";

// unit
export const SEARCH_UNIT = "SEARCH_UNIT";

// owners

export const SEARCH_OWNER = "SEARCH_OWNER";

// buildings
export const SEARCH_BUILDING = "SEARCH_BUILDING";

// Contract

export const SEARCH_CONTRACT = "SEARCH_CONTRACT";

// Payment
export const SEARCH_PAYMENT = "SEARCH_PAYMENT";

// Tenant
export const SEARCH_TENANT_All = "SEARCH_TENANT_All";
export const SEARCH_TENANT_LINKED = "SEARCH_TENANT_LINKED";
export const SEARCH_TENANT_REQUEST = "SEARCH_TENANT_REQUEST";
export const SEARCH_TENANT_UNLINKED = "SEARCH_TENANT_UNLINKED";
export const ACTIVETAB_TENANT = "ACTIVETAB_TENANT";

// Maintanence
//Expert
export const SEARCH_EXPERT = "SEARCH_EXPERT";
//Request
export const SEARCH_REQUESTMAINTENANCE = "SEARCH_REQUEST";
// Expenses
export const SEARCH_EXPENSE = "SEARCH_EXPENSE";
// Active Tab
export const ACTIVETAB_MAINTENANCE = "ACTIVETAB_MAINTENANCE";

// Notification
export const NOTIFICATION = "Notification";
export const BELL_COUNT = "Bell_Count";
export const UNREAD_MESSAGE = "UNREAD_MESSAGE"
export const SEARCH_NOTIFICATION = "SEARCH_NOTIFICATION";
